import React from 'react';
import { BeatLoader, DotLoader, HashLoader } from 'react-spinners';
import { Loading } from './styled';

const Spinner = (props) => {
  let error = props.error;

  // 横向三个点，轮训透明度变化
  /*<BeatLoader size={15} color={props.chatThemeColor} loading/>*/

  // 两个点，z轴x轴旋转时大小变化
  /*<DotLoader size={30} color={props.chatThemeColor} loading/>*/

  return (
    <Loading id="chat-loading">
      {error ? (
        <span>{error}</span>
      ) : (
        <HashLoader size={30} color={props.chatThemeColor} loading>
          Loading...
        </HashLoader>
      )}
    </Loading>
  );
};

export default Spinner;
